import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import Loading from "./loader";
import {enqueueSnackbar} from "notistack";
import { Dropdown, Menu, Modal } from "antd";
import { Tooltip } from "antd";
import { InfoCircleOutlined, EllipsisOutlined, ArrowLeftOutlined, CaretLeftOutlined, CaretRightOutlined } from "@ant-design/icons";
import Swal from 'sweetalert2';
import 'flatpickr/dist/flatpickr.css';
import UserFormModal from "./UserFormModal";
import StateWarning from './StateWarning';
import closeImage from './images/close.png';

class VoteUsers extends Component {
    state = {
        users: [],
        totalUsersCount: 0,
        currentPage: 1,
        pageSize: 10,
        selectedUser: null,
        selectedIndex: null,
        searchQuery: '',
        editingUser: null,
        isModalVisible: false,
        isCalendarVisible: false,
        filters: [],
        isLoading: true,
        isCreateUserModalVisible: false,
        sortBy: 'full_name',
        sortDirection: 'asc',
        meetingName: ''
    };

    async componentDidMount() {
        const { is_staff, is_superuser } = this.props;

        if (!is_staff && !is_superuser) {
            alert("Доступ запрещен");
            window.location.href = `/#/`;
            return;
        }

        await this.loadUsers(1);
        this.setState({ isLoading: false });
    }

    async componentDidUpdate(prevProps) {
        const { is_staff, is_superuser } = this.props;
        if (
            prevProps.is_staff !== is_staff ||
            prevProps.is_superuser !== is_superuser
        ) {
            if (!is_staff && !is_superuser) {
                alert("Доступ запрещен");
                window.location.href = `/#/`;
            }
        }
    }

    getRenderKey() {
        const { currentPage, pageSize, sortBy, sortDirection, filters, searchQuery } = this.state;
        return `users-${currentPage}-${pageSize}-${sortBy}-${sortDirection}-${filters.length}-${searchQuery}`;
    }

    loadUsers = async () => {
      const { match } = this.props;
      const meetingId = match.params.meetingId;
      if (!meetingId) {
        this.setState({ error: "Не указан ID собрания", isLoading: false });
        return;
      }
      const API_ADDRESS = process.env.REACT_APP_API_ADDRESS;
      try {
        // Загружаем пользователей
        const usersResponse = await fetch(`${API_ADDRESS}get_users/?meeting_id=${meetingId}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });

        if (usersResponse.ok) {
          const usersData = await usersResponse.json();
          const totalUsersCount = usersResponse.headers.get('X-Total-Count');

          // Загружаем информацию о собрании
          const meetingResponse = await fetch(`${API_ADDRESS}get_meeting_name/${meetingId}/`, {
              headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
              },
          });

          let meetingName = '';
          if (meetingResponse.ok) {
            const meetingData = await meetingResponse.json();
            meetingName = meetingData.meeting_name || '';
          }

          this.setState({
            users: usersData,
            totalUsersCount: parseInt(totalUsersCount, 10),
            meetingName: meetingName,
            isLoading: false,
          });
        } else {
          const errorData = await usersResponse.json();
          alert(errorData.error || "Ошибка при загрузке пользователей");
          this.setState({ isLoading: false });
        }
      } catch (e) {
        console.error(e);
        alert("Произошла ошибка. Попробуйте еще раз.");
        this.setState({ isLoading: false });
      }
    };

    getPaginatedUsers = () => {
        const { users, currentPage, pageSize, filters, searchQuery, sortBy, sortDirection } = this.state;

        // Фильтрация
        let filteredUsers = users.filter((user) =>
            user.username.toLowerCase().includes(searchQuery.toLowerCase()) ||
            user.email.toLowerCase().includes(searchQuery.toLowerCase()) ||
            (user.full_name && user.full_name.toLowerCase().includes(searchQuery.toLowerCase())) ||
            (user.born && user.born.includes(searchQuery)) ||
            (user.s_n && user.s_n.includes(searchQuery))
        );

        if (filters.length > 0) {
            filteredUsers = filteredUsers.filter((user) =>
                filters.every((filter) =>
                    user.username.toLowerCase().includes(filter.toLowerCase()) ||
                    user.email.toLowerCase().includes(filter.toLowerCase()) ||
                    (user.full_name && user.full_name.toLowerCase().includes(filter.toLowerCase())) ||
                    (user.born && user.born.includes(filter)) ||
                    (user.s_n && user.s_n.includes(filter))
                )
            );
        }

        // Сортировка
        const sortedUsers = [...filteredUsers].sort((a, b) => {
            const order = sortDirection === 'asc' ? 1 : -1; // asc = А-Я

            if (sortBy === 'full_name') {
                const nameA = (a.full_name || '').trim().toUpperCase();
                const nameB = (b.full_name || '').trim().toUpperCase();

                const isARussian = /^[А-ЯЁ]/.test(nameA);
                const isBRussian = /^[А-ЯЁ]/.test(nameB);

                if (isARussian && isBRussian) {
                    return nameA.localeCompare(nameB, 'ru-RU') * order;
                }
                if (!isARussian && !isBRussian) {
                    return nameA.localeCompare(nameB, 'en-US') * order;
                }
                return (isARussian ? -1 : 1) * order;
            }

            // Сортировка по дате рождения
            if (sortBy === 'born') {
                // API возвращает дату в формате ГГГГ-ММ-ДД
                const dateA = a.born ? new Date(a.born) : null;
                const dateB = b.born ? new Date(b.born) : null;

                // Если одна из дат отсутствует, помещаем её в конец
                if (!dateA && !dateB) return 0;
                if (!dateA) return 1 * order;
                if (!dateB) return -1 * order;

                return (dateA - dateB) * order;
            }

            return 0;
        });

        // Пагинация
        const startIndex = (currentPage - 1) * pageSize;
        const endIndex = startIndex + pageSize;
        return sortedUsers.slice(startIndex, endIndex);
    };

    handleSort = (field) => {
        this.setState(
            (prevState) => {
                let newDirection = 'asc';
                let newSortBy = field;

                if (prevState.sortBy === field) {
                    newDirection = prevState.sortDirection === 'asc' ? 'desc' : 'asc';
                } else {
                    newDirection = 'asc';
                }

                return {
                    sortBy: newSortBy,
                    sortDirection: newDirection,
                    currentPage: 1,
                    selectedIndex: null,
                    selectedUser: null,
                };
            },
            this.getPaginatedUsers
        );
    };

    getSortIndicator = (field) => {
        const { sortBy, sortDirection } = this.state;
        if (sortBy !== field) {
            return { activeAsc: false, activeDesc: false };
        }
        return {
            activeAsc: sortDirection === 'asc',
            activeDesc: sortDirection === 'desc'
        };
    };

    handleSearchChange = (e) => {
        const { value } = e.target;
        this.setState({ searchQuery: value });
        if (e.key === 'Enter' && value.trim() !== '') {
            this.setState((prevState) => ({
                filters: [...prevState.filters, value.trim()],
                searchQuery: '',
                currentPage: 1,
                selectedIndex: null,
                selectedUser: null,
            }));
        }
    };

    removeFilter = (filterToRemove) => {
        this.setState((prevState) => ({
            filters: prevState.filters.filter((filter) => filter !== filterToRemove),
            currentPage: 1,
            selectedIndex: null,
            selectedUser: null,
        }));
    };

    selectItem = (index) => {
        const { selectedIndex, users } = this.state;
        const paginatedUsers = this.getPaginatedUsers();

        if (selectedIndex === index) {
            this.setState({ selectedIndex: null, selectedUser: null });
        } else {
            this.setState({ selectedIndex: index }, () => {
                setTimeout(() => {
                    const row = document.querySelector(`.adm-table tbody tr:nth-child(${index + 1})`);
                    const wrapper = document.querySelector('.table-wrapper');

                    if (row && wrapper) {
                        const rowRect = row.getBoundingClientRect();
                        const wrapperRect = wrapper.getBoundingClientRect();
                        const top = rowRect.top - wrapperRect.top + rowRect.height / 2;

                        this.setState({
                            selectedUser: {
                                data: paginatedUsers[index],
                                rowTop: top,
                            },
                        });
                    }
                }, 0);
            });
        }
    };

    handleBackClick = () => {
        window.history.back();
    };

    handleUrlSend = async (user) => {
        if (!user || !user.email) {
            enqueueSnackbar('У пользователя не указан email', { variant: 'error' });
            return;
        }

        Modal.confirm({
            title: 'Отправление ссылки на вход',
            content: (
                <div style={{ textAlign: 'left' }}>
                    Ссылка будет отправлена на почту: <strong style={{ color: '#1677ff' }}>{user.email}</strong>
                </div>
            ),
            okText: 'Отправить',
            okType: 'primary',
            cancelText: 'Отмена',
            onOk: () => {
                this.sendLoginLink(user.email, user.id);
            },
            onCancel() {
            },
        });
    };

    sendLoginLink = async (email, userId) => {
        const API_ADDRESS = process.env.REACT_APP_API_ADDRESS;
        try {
            Swal.fire({
                title: 'Отправка ссылки...',
                html: 'Пожалуйста, подождите, пока ссылка будет отправлена.',
                allowOutsideClick: false,
                showConfirmButton: false,
                didOpen: () => { Swal.showLoading(); }
            });

            const response = await fetch(`${API_ADDRESS}send_login_link/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
                body: JSON.stringify({
                    email: email,
                    user_id: userId,
                }),
            });

            const data = await response.json();

            if (response.ok) {
                if (data.status === "OK") {
                    if (data.message === "Ссылка уже существует") {
                        enqueueSnackbar('Ссылка уже существует', { variant: 'warning' });
                    } else {
                        enqueueSnackbar('Ссылка успешно отправлена', { variant: 'success' });
                    }
                } else {
                    enqueueSnackbar('Ошибка при отправке ссылки', { variant: 'error' });
                }
            } else {
                enqueueSnackbar('Ошибка при отправке ссылки', { variant: 'error' });
            }
        } catch (error) {
            console.error('Ошибка при отправке ссылки:', error);
            enqueueSnackbar('Произошла ошибка при отправке ссылки', { variant: 'error' });
        } finally {
            Swal.close();
        }
    };

    handleEditUser = (user) => {
        this.setState({
            editingUser: user,
            isCreateUserModalVisible: true,
        });
    };

    handleUserCreateClick = () => {
        this.setState({
            editingUser: null,
            isCreateUserModalVisible: true,
        });
    };

    renderFilters() {
        const { filters } = this.state;

        return (
            <div className="filters-container">
                {filters.map((filter, index) => (
                    <div key={index} className="filter-tag">
                        {filter}
                        <img
                            src={closeImage}
                            alt="Удалить"
                            style={{
                                cursor: 'pointer',
                                width: '15px',
                                height: '15px'
                            }}
                            onClick={() => this.removeFilter(filter)}
                        />
                    </div>
                ))}
            </div>
        );
    }

    // --- Метод пагинации ---
    renderPagination = (totalPages) => {
        const { currentPage } = this.state;
        const groupSize = 10;
        const currentGroup = Math.ceil(currentPage / groupSize);
        const startPage = (currentGroup - 1) * groupSize + 1;
        const endPage = Math.min(currentGroup * groupSize, totalPages);

        const goToPage = (page) => {
            if (page >= 1 && page <= totalPages) {
                this.setState({
                    currentPage: page,
                    selectedIndex: null,
                    selectedUser: null,
                });
            }
        };

        const goToPrevGroup = () => {
            const prevStart = startPage - groupSize;
            const newPage = prevStart >= 1 ? prevStart : 1;
            this.setState({
                currentPage: newPage,
                selectedIndex: null,
                selectedUser: null,
            });
        };

        const goToNextGroup = () => {
            const nextStart = startPage + groupSize;
            if (nextStart <= totalPages) {
                this.setState({
                    currentPage: nextStart,
                    selectedIndex: null,
                    selectedUser: null,
                });
            }
        };

        return (
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', width: '100%' }}>
                {/* Первая строка — номера страниц */}
                <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', justifyContent: 'center' }}>
                    {Array.from({ length: endPage - startPage + 1 }, (_, i) => {
                        const page = startPage + i;
                        return (
                            <button5
                                key={page}
                                className={`pagination-button ${currentPage === page ? 'active' : ''}`}
                                onClick={() => goToPage(page)}
                            >
                                {page}
                            </button5>
                        );
                    })}
                </div>

                {/* Вторая строка — стрелки */}
                {(currentGroup > 1 || currentGroup * groupSize < totalPages) && (
                    <div style={{ display: 'flex', gap: '6px', marginTop: '8px' }}>
                        {currentGroup > 1 && (
                            <button5
                                className="pagination-button"
                                onClick={goToPrevGroup}
                                style={{ fontWeight: 'bold', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                aria-label="Предыдущие 10 страниц"
                            >
                                <CaretLeftOutlined style={{ fontSize: '12px' }} />
                            </button5>
                        )}
                        {currentGroup * groupSize < totalPages && (
                            <button5
                                className="pagination-button"
                                onClick={goToNextGroup}
                                style={{ fontWeight: 'bold', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                aria-label="Следующие 10 страниц"
                            >
                                <CaretRightOutlined style={{ fontSize: '12px' }} />
                            </button5>
                        )}
                    </div>
                )}
            </div>
        );
    };

    render() {
        const {
            selectedIndex,
            searchQuery,
            users,
            currentPage,
            pageSize,
            filters
        } = this.state;
        const isButtonDisabled = selectedIndex === null;

        // Фильтрация пользователей по поисковому запросу
        let filteredUsers = users.filter((user) =>
            user.username.toLowerCase().includes(searchQuery.toLowerCase()) ||
            user.email.toLowerCase().includes(searchQuery.toLowerCase()) ||
            (user.full_name && user.full_name.toLowerCase().includes(searchQuery.toLowerCase())) ||
            (user.born && user.born.includes(searchQuery)) ||
            (user.s_n && user.s_n.includes(searchQuery))
        );

        if (filters.length > 0) {
            filteredUsers = filteredUsers.filter((user) =>
                filters.every((filter) =>
                    user.username.toLowerCase().includes(filter.toLowerCase()) ||
                    user.email.toLowerCase().includes(filter.toLowerCase()) ||
                    (user.full_name && user.full_name.toLowerCase().includes(filter.toLowerCase())) ||
                    (user.born && user.born.includes(filter)) ||
                    (user.s_n && user.s_n.includes(filter))
                )
            );
        }

        // Получение пользователей текущей страницы
        const paginatedUsers = this.getPaginatedUsers();
        // Вычисление количества страниц
        const totalPages = Math.ceil(filteredUsers.length / pageSize);

        // Меню действий для выбранного пользователя
        const actionMenu = (user) => (
            <Menu>
                <Menu.Item key="edit" onClick={() => this.handleEditUser(user)}>
                    Редактировать
                </Menu.Item>
                <Menu.Item key="sendLink" onClick={() => this.handleUrlSend(user)}>
                    Отправить ссылку на вход
                </Menu.Item>
            </Menu>
        );

        if (this.state.isLoading) {
            return <div><Loading /></div>;
        }

        return (
            <>
                <div className="page-container">
                    <div className="header-container">
                        <div style={{display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px'}}>
                            <div className="back-button-wrapper" onClick={this.handleBackClick}>
                                <ArrowLeftOutlined
                                    style={{fontSize: '20px', cursor: 'pointer', marginTop: '4px'}}
                                />
                            </div>
                            <h1>Участники собрания</h1>
                        </div>
                    </div>
                    {users.length > 0 && (
                        <div className="search-input">
                            <input
                                type="text"
                                placeholder="Поиск..."
                                value={this.state.searchQuery}
                                onChange={this.handleSearchChange}
                                onKeyDown={this.handleSearchChange}
                                className="main-input4 default-text-style"
                            />
                            <Tooltip
                                title="В строке можно использовать последовательную фильтрацию по разным условиям. Нажмите Enter после ввода данных для создания одного условия"
                                placement="right">
                                <InfoCircleOutlined style={{fontSize: '18px', color: '#000', cursor: 'pointer'}}/>
                            </Tooltip>
                        </div>
                    )}
                    <div className="search-tags">
                        {this.renderFilters()}
                    </div>

                    {this.state.meetingName && paginatedUsers.length > 0 && (
                      <div className="username-container">
                        <b>Собрание:</b>{' '}
                        <span className="username-badge">
                          {this.state.meetingName}
                        </span>
                      </div>
                    )}

                    {paginatedUsers.length > 0 ? (
                        <div className="table-wrapper">
                            <div
                                key={this.getRenderKey()}
                                className="table-animated-container"
                                style={{
                                    opacity: 0,
                                    animation: 'fadeIn 0.3s ease-in-out forwards'
                                }}
                            >
                                <div className="table-adm-container">
                                    <table className="adm-table">
                                        <thead>
                                        <tr>
                                            <th>№</th>
                                            <th
                                                onClick={() => this.handleSort('full_name')}
                                                style={{cursor: 'pointer', position: 'relative', whiteSpace: 'normal'}}
                                            >
                                                ФИО
                                                <span style={{marginLeft: '8px', fontSize: '14px', marginTop: '-10px'}}>
                                                <span
                                                    style={{
                                                        color: this.getSortIndicator('full_name').activeAsc ? '#007bff' : '#666',
                                                        fontWeight: 'bold'
                                                    }}
                                                >
                                                    ↑
                                                </span>
                                                <span
                                                    style={{
                                                        color: this.getSortIndicator('full_name').activeDesc ? '#007bff' : '#666',
                                                        fontWeight: 'bold',
                                                        marginLeft: '1px'
                                                    }}
                                                >
                                                    ↓
                                                </span>
                                            </span>
                                            </th>
                                            <th>Номер телефона</th>
                                            <th>Почта</th>
                                            <th>Серия и номер паспорта</th>
                                            <th
                                                onClick={() => this.handleSort('born')}
                                                style={{cursor: 'pointer', position: 'relative', whiteSpace: 'normal'}}
                                            >
                                                Дата рождения
                                                <span style={{marginLeft: '8px', fontSize: '14px', marginTop: '-10px'}}>
                                                <span
                                                    style={{
                                                        color: this.getSortIndicator('born').activeAsc ? '#007bff' : '#666',
                                                        fontWeight: 'bold'
                                                    }}
                                                >
                                                    ↑
                                                </span>
                                                <span
                                                    style={{
                                                        color: this.getSortIndicator('born').activeDesc ? '#007bff' : '#666',
                                                        fontWeight: 'bold',
                                                        marginLeft: '1px'
                                                    }}
                                                >
                                                    ↓
                                                </span>
                                            </span>
                                            </th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {paginatedUsers.map((user, index) => {
                                            const globalIndex = (currentPage - 1) * pageSize + index + 1;
                                            const isSelected = selectedIndex === index;
                                            return (
                                                <tr
                                                    key={user.id}
                                                    className={isSelected ? 'selected' : ''}
                                                    onClick={() => this.selectItem(index)}
                                                    style={{cursor: 'pointer'}}
                                                >
                                                    <td>{globalIndex}</td>
                                                    <td>{user.full_name || "-"}</td>
                                                    <td>{user.username || "-"}</td>
                                                    <td>{user.email || "-"}</td>
                                                    <td>{user.s_n || "-"}</td>
                                                    <td>{user.born ? user.born.split('-').reverse().join('.') : "-"}</td>
                                                </tr>
                                            );
                                        })}
                                        </tbody>
                                    </table>
                                    {/* Пагинация */}
                                    <div className="pagination-container">
                                        {totalPages > 1 && this.renderPagination(totalPages)}
                                    </div>
                                </div>
                            </div>
                            {this.state.selectedUser && (
                                <div
                                    style={{
                                        position: 'absolute',
                                        left: 'calc(50% + 25% + 10px)',
                                        top: this.state.selectedUser.rowTop,
                                        transform: 'translateY(-50%)',
                                        zIndex: 10,
                                        backgroundColor: 'white',
                                        padding: '5px 8px',
                                        border: '1px solid #000',
                                        borderRadius: '4px',
                                        boxShadow: '0 0 5px rgba(0,0,0,0.1)',
                                    }}
                                >
                                    <Dropdown overlay={actionMenu(this.state.selectedUser.data)} trigger={['click']}>
                                        <EllipsisOutlined
                                            style={{
                                                fontSize: '18px',
                                                cursor: 'pointer',
                                                color: '#1890ff',
                                            }}
                                        />
                                    </Dropdown>
                                </div>
                            )}
                        </div>
                    ) : (
                        <StateWarning message={`Пользователи отсутствуют для собрания (${this.state.meetingName})`} />
                    )}
                    <UserFormModal
                        key={this.state.editingUser?.id || 'create'}
                        visible={this.state.isCreateUserModalVisible}
                        onClose={() => this.setState({isCreateUserModalVisible: false, editingUser: null})}
                        onCreateSuccess={() => {
                            this.loadUsers();
                        }}
                        onUpdateSuccess={() => {
                            this.loadUsers();
                        }}
                        userToEdit={this.state.editingUser}
                        currentUserIsSuperuser={this.props.is_superuser}
                        currentUserIsStaff={this.props.is_staff}
                    />
                </div>
            </>
        );
    }
}

export default withRouter(VoteUsers);